import { useCallback, useMemo, useState } from "react";
import { API } from "aws-amplify";

import { gtp } from "api/graphql/mutations.js";

export const NotificationState = {
  IDLE: "IDLE",
  SENDING: "SENDING",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};

const CONFIRMATION_EMAIL_LABELS = {
  [NotificationState.IDLE]: "Send Confirmation Email",
  [NotificationState.SENDING]: "Sending Confirmation Email",
  [NotificationState.SUCCESS]: "Confirmation Email Sent",
  [NotificationState.ERROR]: "Retry Confirmation Email",
};

const CONFIRMATION_EMAIL_TOOLTIPS = {
  [NotificationState.IDLE]: "Send confirmation email to claim account",
  [NotificationState.SENDING]: "Sending confirmation email",
  [NotificationState.SUCCESS]: "Confirmation email sent",
  [NotificationState.ERROR]: "Error sending confirmation email",
};

export function useConfirmationEmailNotification(email) {
  const [notificationState, setNotificationState] = useState(
    NotificationState.IDLE
  );

  const sendUserNotification = useCallback(async () => {
    setNotificationState(NotificationState.SENDING);
    try {
      await API.graphql({
        query: gtp,
        variables: { input: { email, sendTemplate: true } },
        authMode: "API_KEY",
      });
      setNotificationState(NotificationState.SUCCESS);
    } catch (error) {
      console.error("Error sending user notification:", error);
      setNotificationState(NotificationState.ERROR);
    }
  }, [email]);

  const confirmationEmailLabel = useMemo(
    () => CONFIRMATION_EMAIL_LABELS[notificationState],
    [notificationState]
  );

  const confirmationEmailTooltip = useMemo(
    () => CONFIRMATION_EMAIL_TOOLTIPS[notificationState],
    [notificationState]
  );

  return {
    confirmationEmailLabel,
    confirmationEmailTooltip,
    isSendingConfirmationEmail: notificationState === NotificationState.SENDING,
    notificationState,
    sendUserNotification,
  };
}
